import api from '../api/client'
import { contem } from '../utils/texto'

const clientesService = {
  // Listar clientes
  listarClientes: async (organizadorId, page = 1, limit = 20, search = '') => {
    const params = new URLSearchParams({ page, limit })
    if (search) params.append('search', search)
    
    const response = await api.get(`/organizadores/${organizadorId}/clientes?${params}`)
    return response.data
  },

  getByOrganizador: async (organizadorId, page = 1, limit = 20, search = '', filters = {}) => {
    const params = new URLSearchParams({ page, limit })
    if (search) params.append('search', search)
    if (filters.grupo) params.append('grupo', filters.grupo)
    if (filters.cidade) params.append('cidade', filters.cidade)
    if (filters.is_socio) params.append('is_socio', filters.is_socio)
    if (filters.inativos) params.append('inativos', filters.inativos)
    
    const response = await api.get(`/organizadores/${organizadorId}/clientes?${params}`)
    return response.data
  },

  // Buscar cliente por ID
  getById: async (organizadorId, clienteId) => {
    const response = await api.get(`/organizadores/${organizadorId}/clientes/${clienteId}`)
    return response.data
  },

  // Criar cliente
  create: async (organizadorId, clienteData) => {
    const response = await api.post(`/organizadores/${organizadorId}/clientes`, {
      ...clienteData,
      organizador_id: organizadorId
    })
    return response.data
  },

  // Atualizar cliente
  update: async (organizadorId, clienteId, clienteData) => {
    const response = await api.put(`/organizadores/${organizadorId}/clientes/${clienteId}`, clienteData)
    return response.data
  },

  // Excluir cliente
  delete: async (organizadorId, clienteId) => {
    const response = await api.delete(`/organizadores/${organizadorId}/clientes/${clienteId}`)
    return response.data
  },

  // Buscar clientes por nome
  searchByName: async (organizadorId, query) => {
    const response = await api.get(`/organizadores/${organizadorId}/clientes/search?q=${encodeURIComponent(query)}`)
    return response.data
  },

  // Buscar clientes por CPF/CNPJ parecido (evitar duplicatas)
  searchByCpfCnpj: async (organizadorId, query) => {
    const response = await api.get(`/organizadores/${organizadorId}/clientes/search-cpf-cnpj?q=${encodeURIComponent(query)}`)
    return response.data
  },

  // Fazendas
  createFazenda: async (organizadorId, clienteId, fazendaData) => {
    const response = await api.post(`/organizadores/${organizadorId}/clientes/${clienteId}/fazendas`, fazendaData)
    return response.data
  },

  updateFazenda: async (organizadorId, clienteId, fazendaId, fazendaData) => {
    const response = await api.put(`/organizadores/${organizadorId}/clientes/${clienteId}/fazendas/${fazendaId}`, fazendaData)
    return response.data
  },

  deleteFazenda: async (organizadorId, clienteId, fazendaId) => {
    const response = await api.delete(`/organizadores/${organizadorId}/clientes/${clienteId}/fazendas/${fazendaId}`)
    return response.data
  },

  // Dados Bancários
  createDadoBancario: async (organizadorId, clienteId, dadoData) => {
    const response = await api.post(`/organizadores/${organizadorId}/clientes/${clienteId}/dados-bancarios`, dadoData)
    return response.data
  },

  updateDadoBancario: async (organizadorId, clienteId, dadoId, dadoData) => {
    const response = await api.put(`/organizadores/${organizadorId}/clientes/${clienteId}/dados-bancarios/${dadoId}`, dadoData)
    return response.data
  },

  deleteDadoBancario: async (organizadorId, clienteId, dadoId) => {
    const response = await api.delete(`/organizadores/${organizadorId}/clientes/${clienteId}/dados-bancarios/${dadoId}`)
    return response.data
  },

  // Mesclar clientes duplicados
  previewMesclar: async (organizadorId, origemId, destinoId) => {
    const response = await api.get(
      `/organizadores/${organizadorId}/clientes/${origemId}/mesclar/preview?destino_id=${destinoId}`
    )
    return response.data
  },

  mesclar: async (organizadorId, origemId, destinoId) => {
    const response = await api.post(
      `/organizadores/${organizadorId}/clientes/${origemId}/mesclar`,
      { destino_id: destinoId }
    )
    return response.data
  },

  // Balanço do cliente
  getBalanco: async (organizadorId, clienteId, params = {}) => {
    const qs = new URLSearchParams()
    if (params.data_inicio) qs.append('data_inicio', params.data_inicio)
    if (params.data_fim) qs.append('data_fim', params.data_fim)
    if (params.situacao) qs.append('situacao', params.situacao)
    const query = qs.toString()
    const response = await api.get(`/organizadores/${organizadorId}/clientes/${clienteId}/balanco${query ? `?${query}` : ''}`)
    return response.data
  },

  getBalancoPdf: async (organizadorId, clienteId, params = {}) => {
    const qs = new URLSearchParams()
    if (params.data_inicio) qs.append('data_inicio', params.data_inicio)
    if (params.data_fim) qs.append('data_fim', params.data_fim)
    if (params.situacao) qs.append('situacao', params.situacao)
    const query = qs.toString()
    const response = await api.get(
      `/organizadores/${organizadorId}/clientes/${clienteId}/balanco/pdf${query ? `?${query}` : ''}`,
      { responseType: 'blob', timeout: 60000 }
    )
    return response.data
  },

  // Histórico de envios do link de cadastro público
  getSubmissoesCadastroPublico: async (organizadorId, clienteId) => {
    const response = await api.get(`/organizadores/${organizadorId}/clientes/${clienteId}/cadastro-publico-submissoes`)
    return response.data
  },

  // Todos os envios do link de cadastro público (todos os clientes), paginado
  listarTodasSubmissoesCadastroPublico: async (organizadorId, page = 1, perPage = 20) => {
    const response = await api.get(`/organizadores/${organizadorId}/cadastro-publico-submissoes`, {
      params: { page, per_page: perPage }
    })
    return response.data
  },

  contarNovasSubmissoesCadastroPublico: async (organizadorId) => {
    const response = await api.get(`/organizadores/${organizadorId}/cadastro-publico-submissoes/novas-contagem`)
    return response.data
  },

  marcarVistasSubmissoesCadastroPublico: async (organizadorId) => {
    const response = await api.post(`/organizadores/${organizadorId}/cadastro-publico-submissoes/marcar-vistas`)
    return response.data
  },

  // PDF da ficha do cliente (impressão com abas selecionáveis)
  getFichaPdf: async (organizadorId, clienteId, secoes = []) => {
    const response = await api.get(`/organizadores/${organizadorId}/clientes/${clienteId}/ficha-pdf`, {
      params: { secoes: secoes.join(',') },
      responseType: 'blob',
      timeout: 60000
    })
    return response.data
  },

  // Buscar cidades
  searchCidades: async (termo) => {
    try {
      // Usar API do IBGE para buscar cidades
      const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/municipios`)
      const municipios = await response.json()
      
      // Filtrar por termo de busca
      const cidadesFiltradas = municipios
        .filter(municipio => 
          contem(municipio.nome, termo.toLowerCase())
        )
        .map(municipio => ({
          nome: municipio.nome,
          uf: municipio.microrregiao.mesorregiao.UF.sigla
        }))
        .slice(0, 10) // Limitar a 10 resultados
      
      return cidadesFiltradas
    } catch (error) {
      console.error('Erro ao buscar cidades:', error)
      // Fallback com dados simulados
      const cidades = [
        { nome: 'Uberlândia', uf: 'MG' },
        { nome: 'Uberaba', uf: 'MG' },
        { nome: 'Belo Horizonte', uf: 'MG' },
        { nome: 'São Paulo', uf: 'SP' },
        { nome: 'Rio de Janeiro', uf: 'RJ' },
        { nome: 'Brasília', uf: 'DF' },
        { nome: 'Goiânia', uf: 'GO' },
        { nome: 'Campo Grande', uf: 'MS' },
        { nome: 'Cuiabá', uf: 'MT' },
        { nome: 'Salvador', uf: 'BA' }
      ]
      
      return cidades.filter(cidade => 
        contem(cidade.nome, termo.toLowerCase())
      )
    }
  }
}

export default clientesService